module.exports = __webpack_public_path__ + "img/bg-intro-mobile.c23dd1d0.svg";